import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { LOCALE_ID, NgModule, StaticClassProvider } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { HttpLoaderFactory, UtilsService } from '../core';
import { FeatureSharedModule } from '../features/shared/feature-shared.module';

import { BreadcrumbModule } from './components/breadcrumb/breadcrumb.module';
import { ButtonComponent } from './components/button/button.component';
import { CapacityInfoModule } from './components/capacity-info/capacity-info.module';
import { WideCardComponent } from './components/ui-components/wide-card/wide-card.component';
import { CardsModule } from './components/cards/cards.module';
import { ChartioComponent } from './components/chartio/chartio.component';
import { ChipComponent } from './components/ui-components/chip/chip.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { EventCardComponent } from './components/ui-components/event-card/event-card.component';
import { MultiStepFormComponent } from './components/multi-step-form/multi-step-form.component';
import { OXIOMetricsComponent } from './components/oxio-metrics/oxio-metrics.component';
import { PasswordRequirementsComponent } from './components/password-requirements/password-requirements.component';
import { RouterComponent } from './components/router/router.component';
import { SelectLanguageComponent } from './components/select-language/select-language.component';
import { SelectComponent } from './components/select/select.component';
import { SisenseMetricsComponent } from './components/sisense-metrics/sisense-metrics.component';
import { SocialModule } from './components/social/social.module';
import { TablesModule } from './components/tables/tables.module';
import { TabsetComponent } from './components/tabset/tabset.component';
import { DirectivesModule } from './directives/directives.modules';
import { PipesModule } from './pipes/pipes.module';
import { PaymentChannelsTypeAvatarComponent } from './components/features-components/payment-channels-type-avatar/payment-channels-type-avatar.component';

class DynamicLocaleId extends String {
  constructor(protected service: TranslateService) {
    super('');
  }

  toString() {
    return this.service.currentLang;
  }
}

const LocaleProvider: StaticClassProvider = {
  provide: LOCALE_ID,
  useClass: DynamicLocaleId,
  deps: [TranslateService],
};

@NgModule({
  declarations: [
    ButtonComponent,
    DropdownComponent,
    EventCardComponent,
    TabsetComponent,
    RouterComponent,
    ChartioComponent,
    OXIOMetricsComponent,
    SelectLanguageComponent,
    PasswordRequirementsComponent,
    SelectComponent,
    MultiStepFormComponent,
    SisenseMetricsComponent,
    ChipComponent,
    WideCardComponent,
    PaymentChannelsTypeAvatarComponent,
  ],
  exports: [
    WideCardComponent,
    DirectivesModule,
    BreadcrumbModule,
    ButtonComponent,
    DropdownComponent,
    EventCardComponent,
    TabsetComponent,
    RouterComponent,
    PipesModule,
    NzPaginationModule,
    CardsModule,
    ChartioComponent,
    OXIOMetricsComponent,
    TranslateModule,
    SocialModule,
    TablesModule,
    SelectLanguageComponent,
    PasswordRequirementsComponent,
    NzSpinModule,
    SelectComponent,
    MultiStepFormComponent,
    NzStepsModule,
    SisenseMetricsComponent,
    CapacityInfoModule,
    ChipComponent,
    PaymentChannelsTypeAvatarComponent,
  ],
  providers: [UtilsService, LocaleProvider],
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    FeatureSharedModule,
    PipesModule,
    CommonModule,
    RouterModule,
    NzAvatarModule,
    NzButtonModule,
    NzIconModule,
    NzDropDownModule,
    NzTabsModule,
    NzTypographyModule,
    NzSelectModule,
    CardsModule,
    TablesModule,
    NzCheckboxModule,
    NzSpinModule,
    NzSwitchModule,
    NzBackTopModule,
    NzLayoutModule,
    NzFormModule,
    NzProgressModule,
    NzStepsModule,
    NzTagModule,
    NzToolTipModule,
    NzTypographyModule,
    TranslateModule.forChild({
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class SharedModule {}
